import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Urbaniamonthlycorporatehire() {



    const cardData =
    {
        keyword: 'Urbania Monthly Corporate Hire Pune',
        heading: 'Urbania on rent in pune: Urbania Monthly Corporate Hire Pune',
        headingDescription: 'Urbania On Rent in Pune provides premium and reliable Urbania Monthly Corporate Hire Pune services for businesses, corporate teams, and organizations requiring long-term group transportation. Our well-maintained Force Urbania fleet offers spacious seating, air-conditioned comfort, and smooth performance, making it ideal for daily office commutes, airport transfers, corporate events, employee transportation, and outstation business trips from Pune. With professional chauffeurs, flexible monthly rental plans, and convenient doorstep pickup from major business hubs including Hinjewadi, Baner, Wakad, Kharadi, Hadapsar, Kothrud, Pimpri Chinchwad, and Pune Airport, we ensure a safe, punctual, and hassle-free travel experience. Supported by 24/7 booking assistance, transparent pricing, and trusted service, Urbania On Rent in Pune stands out as the preferred choice for monthly corporate Urbania hire in Pune.',

        top: 'Top Places to Visit in Pune with Urbania on rent in pune',


 "topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s most iconic fort and a symbol of Maratha glory. Once the seat of Bajirao I’s administration, it features massive stone walls, grand gateways like the Delhi Darwaza, and lush lawns. Although much of it was destroyed in a fire, the remnants still echo royal grandeur. The evening light-and-sound show brings Maratha history to life. Shaniwar Wada stands as Pune’s proud emblem of heritage and valor."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, constructed in 1892, is a monumental landmark tied to India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. The palace now serves as a museum showcasing Gandhi’s personal artifacts and photographs. Its sprawling gardens and Italian arches make it a peaceful retreat. It also houses the samadhis of Kasturba Gandhi and Mahadev Desai. Aga Khan Palace is Pune’s symbol of sacrifice and patriotism."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine, dedicated to Lord Ganesha. The idol, adorned with gold and jewels, attracts thousands of devotees daily. During Ganesh Chaturthi, the temple becomes the epicenter of grand celebrations. The trust behind the temple is also known for its charitable work. Devotees find immense peace and blessings here. Dagdusheth Ganpati is the spiritual heartbeat of Pune."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Situated atop a rugged hill, Sinhagad Fort is famed for the 1670 battle where Tanaji Malusare sacrificed his life for Chhatrapati Shivaji Maharaj. Visitors trek or drive up to explore its ancient ramparts, memorials, and scenic viewpoints. The fort offers breathtaking views of the Sahyadri ranges. Local vendors serve traditional pithla-bhakri meals near the summit. Sinhagad is Pune’s favorite blend of history, adventure, and nature."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an 8th-century rock-cut shrine dedicated to Lord Shiva. Carved from a single basalt rock, it features monolithic pillars, a circular Nandi pavilion, and a peaceful sanctum. Despite being in a busy area, it maintains a tranquil spiritual ambiance. Its ancient carvings are a testament to early Indian craftsmanship. Pataleshwar is Pune’s hidden heritage retreat."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar, showcasing India’s rich cultural past. From traditional ornaments and musical instruments to household antiques and sculptures, it is a treasure trove of heritage. The recreated Mastani Mahal is a major attraction. The museum is Pune’s living archive of art and craftsmanship."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill is one of Pune’s oldest landmarks, offering panoramic views of the city after climbing 103 stone steps. The hilltop Parvati Temple, dedicated to Lord Shiva and Goddess Parvati, was built during the Peshwa era. Smaller shrines and a museum add to its cultural charm. Sunrise and sunset visits are especially mesmerizing. Parvati Hill is Pune’s spiritual and scenic high point."
  },
  {
    "title": "Osho Ashram",
    "description": "Located in Koregaon Park, the Osho International Meditation Resort is a global center for peace and self-discovery. Spread across beautifully landscaped gardens, it offers meditation sessions, wellness therapies, and mindfulness programs. Visitors from around the world come seeking relaxation and transformation. Osho Ashram is Pune’s international retreat for tranquility."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. It features flowing streams, arched bridges, and manicured lawns surrounded by seasonal flowers. Families and photography enthusiasts enjoy peaceful walks here. The garden beautifully blends Japanese aesthetics with Indian nature. It is Pune’s serene green sanctuary."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular leisure spot among locals. The vast waterscape and surrounding hills create a picturesque setting, especially during monsoon. Street vendors selling roasted corn and tea add to the charm. It also serves as the gateway to Sinhagad Fort. Khadakwasla is Pune’s breezy escape for weekends and sunsets."
  }
],



"services": [
    {
      "name": "Urbania Monthly Corporate Hire Pune",
      "description": "Urbania Monthly Corporate Hire Pune provides long-term vehicle rental solutions for corporate offices, ensuring reliable and comfortable transportation for employees on a monthly basis. Vehicles are well-maintained, air-conditioned, and equipped with professional chauffeurs, guaranteeing punctual and hassle-free travel every day."
    },
    {
      "name": "Corporate Urbania Monthly Rental Pune",
      "description": "Corporate Urbania Monthly Rental Pune offers flexible monthly rental options for corporate clients. Perfect for daily office commutes, staff transportation, and corporate trips, the service ensures safety, comfort, and reliability with spacious vehicles and trained chauffeurs."
    },
    {
      "name": "Urbania Long Term Hire Pune",
      "description": "Urbania Long Term Hire Pune provides convenient and cost-effective solutions for businesses and organizations requiring vehicles for extended periods. With well-maintained vehicles, professional drivers, and customized plans, it guarantees efficient, safe, and dependable long-term transportation."
    },
    {
      "name": "Urbania for Company Transportation Pune",
      "description": "Urbania for Company Transportation Pune delivers comprehensive solutions for employee commute, client visits, and corporate events. Vehicles are spacious, air-conditioned, and driven by trained chauffeurs, ensuring punctuality, comfort, and a professional experience for all corporate travel needs."
    },
    {
      "name": "Corporate Employee Transport Urbania Pune",
      "description": "Corporate Employee Transport Urbania Pune offers safe and reliable daily transportation for employees. With well-maintained vehicles, professional drivers, and on-time service, it provides hassle-free commuting for corporate teams, making employee travel convenient and stress-free."
    },
    {
      "name": "Urbania Office Commute Pune",
      "description": "Urbania Office Commute Pune specializes in daily office transportation with comfortable, air-conditioned Urbania vehicles. Ideal for corporate clients, IT companies, and small to large organizations, it ensures timely pickups, safe travel, and courteous chauffeur service for all employees."
    },
    {
      "name": "Urbania AC Corporate Bus Pune",
      "description": "Urbania AC Corporate Bus Pune provides fully air-conditioned buses for corporate travel, employee shuttles, and team outings. With spacious seating, professional chauffeurs, and reliable service, it ensures a comfortable, safe, and punctual commute for large groups of employees."
    },
    {
      "name": "Affordable Corporate Urbania Pune",
      "description": "Affordable Corporate Urbania Pune offers cost-effective solutions for corporate transportation without compromising on quality or comfort. Vehicles are well-maintained, equipped with air-conditioning, and driven by trained chauffeurs to provide reliable and economical employee commute and corporate travel options."
    },
    {
      "name": "Chauffeur Driven Corporate Urbania Pune",
      "description": "Chauffeur Driven Corporate Urbania Pune ensures stress-free and safe corporate travel with trained, background-verified drivers. Vehicles are spacious, clean, and suitable for daily office commutes, corporate events, and long-distance business travel."
    },
    {
      "name": "Urbania for IT Companies Pune",
      "description": "Urbania for IT Companies Pune offers customized employee transport solutions specifically for IT firms and corporate campuses. With comfortable air-conditioned vehicles, punctual service, and professional chauffeurs, it ensures a smooth and convenient daily commute for IT professionals."
    },
    {
      "name": "Urbania Contract Hire Pune",
      "description": "Urbania Contract Hire Pune provides long-term corporate transportation services under contract agreements. Ideal for offices, organizations, and companies with continuous travel needs, the service includes well-maintained vehicles, professional drivers, and reliable on-time performance."
    },
    {
      "name": "Best Corporate Urbania Rental Pune",
      "description": "Best Corporate Urbania Rental Pune delivers top-rated corporate vehicle rental services, known for reliability, vehicle quality, and excellent customer service. Perfect for offices, companies, and corporate events, it ensures a smooth, safe, and comfortable commute for employees and executives."
    },
    {
      "name": "Reliable Corporate Urbania Service Pune",
      "description": "Reliable Corporate Urbania Service Pune provides dependable transportation for corporate clients, ensuring punctual pickups, professional chauffeurs, and well-maintained vehicles. Ideal for daily office commutes, corporate trips, and employee transport, it emphasizes consistency and comfort."
    },
    {
      "name": "Urbania for Business Travel Pune",
      "description": "Urbania for Business Travel Pune offers fully equipped vehicles for corporate executives, clients, and teams traveling for business purposes. With comfortable seating, air-conditioning, and professional chauffeurs, it guarantees safe, timely, and efficient transportation for all business travel needs."
    },
    {
      "name": "Monthly Urbania Bus Hire Pune",
      "description": "Monthly Urbania Bus Hire Pune provides cost-effective and reliable long-term rental of air-conditioned buses for corporate clients, employee shuttles, and large team travel. With professional drivers, ample seating, and scheduled services, it ensures a comfortable and stress-free monthly commute solution."
    }
  ],
  "tableData": [
    ["Urbania Monthly Corporate Hire Pune", "Corporate Urbania Monthly Rental Pune"],
    ["Urbania Long Term Hire Pune", "Urbania for Company Transportation Pune"],
    ["Corporate Employee Transport Urbania Pune", "Urbania Office Commute Pune"],
    ["Urbania AC Corporate Bus Pune", "Affordable Corporate Urbania Pune"],
    ["Chauffeur Driven Corporate Urbania Pune", "Urbania for IT Companies Pune"],
    ["Urbania Contract Hire Pune", "Best Corporate Urbania Rental Pune"],
    ["Reliable Corporate Urbania Service Pune", "Urbania for Business Travel Pune"],
    ["Monthly Urbania Bus Hire Pune", ""]
  ],





"whychoose": [
    {
        "WhyChooseheading": "Reliable Urbania Monthly Corporate Hire Pune",
        "WhyChoosedescription": "Urbania Monthly Corporate Hire Pune is ideal for businesses and corporate groups seeking comfortable, spacious, and hassle-free transportation for employees and clients."
    },
    {
        "WhyChooseheading": "Spacious and Comfortable Force Urbania Vehicles",
        "WhyChoosedescription": "Urbania Monthly Corporate Hire Pune provides well-maintained Force Urbania vehicles with ample seating and luggage space, ensuring a smooth and reliable journey every day."
    },
    {
        "WhyChooseheading": "Professional and Experienced Drivers",
        "WhyChoosedescription": "Urbania Monthly Corporate Hire Pune comes with skilled drivers familiar with Pune city routes and highways, ensuring safe, timely, and stress-free corporate travel."
    },
    {
        "WhyChooseheading": "Transparent and Affordable Pricing",
        "WhyChoosedescription": "Choose Urbania Monthly Corporate Hire Pune for competitive monthly rates with no hidden charges, making corporate travel budget-friendly and reliable."
    },
    {
        "WhyChooseheading": "24/7 Booking and Customer Support",
        "WhyChoosedescription": "Urbania Monthly Corporate Hire Pune provides round-the-clock assistance for bookings, inquiries, and last-minute corporate travel requirements."
    },
    {
        "WhyChooseheading": "Flexible Corporate Packages",
        "WhyChoosedescription": "Urbania Monthly Corporate Hire Pune offers flexible packages for daily commutes, corporate events, airport transfers, and employee pick-and-drop services."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Vehicles",
        "WhyChoosedescription": "All vehicles for Urbania Monthly Corporate Hire Pune are regularly cleaned, sanitized, and serviced to ensure a safe and comfortable travel experience."
    },
    {
        "WhyChooseheading": "Punctual and Reliable Service",
        "WhyChoosedescription": "Urbania Monthly Corporate Hire Pune guarantees on-time pickups and dependable service, ensuring smooth and stress-free corporate transportation."
    }
]
}

const faqData = [
    {
        question: 'Is Urbania Monthly Corporate Hire Pune suitable for daily corporate travel?',
        answer: 'Yes, Urbania Monthly Corporate Hire Pune is perfect for daily employee transportation, corporate events, and business meetings within Pune and nearby areas.',
    },
    {
        question: 'How can I book Urbania Monthly Corporate Hire Pune?',
        answer: 'You can book Urbania Monthly Corporate Hire Pune via phone, WhatsApp, or online for quick and hassle-free corporate reservations.',
    },
    {
        question: 'Why choose Urbania Monthly Corporate Hire Pune for corporate groups?',
        answer: 'Urbania Monthly Corporate Hire Pune provides spacious seating, smooth rides, and professional drivers, making it ideal for corporate employees and client transportation.',
    },
    {
        question: 'Are the drivers experienced with Urbania Monthly Corporate Hire Pune?',
        answer: 'Yes, all drivers are professionally trained, licensed, and experienced in handling Force Urbania vehicles for corporate travel.',
    },
    {
        question: 'Can I customize pickup and drop-off locations with Urbania Monthly Corporate Hire Pune?',
        answer: 'Absolutely. Urbania Monthly Corporate Hire Pune allows flexible pickup and drop-off locations across Pune and nearby areas for corporate convenience.',
    },
    {
        question: 'Is Urbania Monthly Corporate Hire Pune available 24x7?',
        answer: 'Yes, Urbania Monthly Corporate Hire Pune operates 24x7 to accommodate corporate travel needs at any time.',
    },
    {
        question: 'Are hygiene and safety standards maintained for Urbania Monthly Corporate Hire Pune?',
        answer: 'Yes, all vehicles are regularly cleaned, sanitized, and maintained with strict safety protocols for corporate travel.',
    },
    {
        question: 'What payment options are available for Urbania Monthly Corporate Hire Pune?',
        answer: 'Urbania Monthly Corporate Hire Pune accepts UPI, digital wallets, credit/debit cards, bank transfers, and corporate billing options.',
    },
    {
        question: 'Is customer support available during the journey?',
        answer: 'Yes, dedicated customer support is available throughout the journey to ensure a smooth and stress-free experience for corporate clients.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Rohit Mehta',
        feedback: 'We booked Urbania Monthly Corporate Hire Pune for our employees. The service is excellent, vehicles are spacious and comfortable, and the drivers are professional.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Priya Kulkarni',
        feedback: 'Urbania Monthly Corporate Hire Pune provided reliable and punctual service for our corporate team every day. Highly recommended!',
        rating: 5,
    },
];

































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Urbania On Rent Pune", link: "urbania-on-rent-pune" },
        { place: "/images/keyword/2.jpg", text: "Urbania on Rent in Pimpri Chinchwad", link: "urbania-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/3.jpg", text: "Urbania Hire for Corporate Events in Pune", link: "urbania-hire-for-corporate-events-in-pune" },
        { place: "/images/keyword/4.jpg", text: "17 Seater Urbania on Rent in Pune", link: "17-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/5.jpg", text: "14 Seater Urbania on Rent in Pune", link: "14-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/6.jpg", text: "Urbania on Rent in Kharadi", link: "urbania-on-rent-in-kharadi" },
        { place: "/images/keyword/7.jpg", text: "Urbania on Rent in Hadapsar", link: "urbania-on-rent-in-hadapsar" },
        { place: "/images/keyword/8.jpg", text: "Urbania on Rent in Kothrud", link: "urbania-on-rent-in-kothrud" },
        { place: "/images/keyword/9.jpg", text: "Urbania On Rent in Bibwewadi", link: "urbania-on-rent-in-bibwewadi" },
        { place: "/images/keyword/10.jpg", text: "Urbania on Rent in Koregaon Park", link: "urbania-on-rent-in-koregaon-park" },
        { place: "/images/keyword/11.jpg", text: "Urbania On Rent in Kalyani Nagar", link: "urbania-on-rent-in-kalyani-nagar" },
        { place: "/images/keyword/12.jpg", text: "Urbania On Rent in Mundhwa Pune", link: "urbania-on-rent-in-mundhwa-pune" },
        { place: "/images/keyword/13.jpg", text: "Urbania Bus On Rent in Baner", link: "urbania-bus-on-rent-in-baner" },
        { place: "/images/keyword/14.jpg", text: "Urbania AC Bus On Rent in Aundh", link: "urbania-ac-bus-on-rent-in-aundh" },
        { place: "/images/keyword/15.jpg", text: "Urbania Bus On Rent in Hinjewadi", link: "urbania-bus-on-rent-in-hinjewadi" },
        { place: "/images/keyword/16.jpg", text: "Urbania on Rent in Bhosari", link: "urbania-on-rent-in-bhosari" },
        { place: "/images/keyword/17.jpg", text: "Urbania on Rent in Pune Station", link: "urbania-on-rent-in-pune-station" },
        { place: "/images/keyword/18.jpg", text: "Urbania On Rent in Chakan", link: "urbania-on-rent-in-chakan" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Moshi", link: "urbania-on-rent-in-moshi" },
        { place: "/images/keyword/20.jpg", text: "Urbania On Rent in Charholi Budruk", link: "urbania-on-rent-in-charholi-budruk" },
        { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Nigdi Pradhikaran", link: "urbania-on-rent-in-nigdi-pradhikaran" },
        { place: "/images/keyword/22.jpg", text: "Urbania On Rent in Lohegaon", link: "urbania-on-rent-in-lohegaon" },
        { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Wagholi", link: "urbania-on-rent-in-wagholi" },
        { place: "/images/keyword/24.jpg", text: "Urbania Rental Service in Pune", link: "urbania-rental-service-in-pune" },
        { place: "/images/keyword/25.jpg", text: "Best Urbania on Rent in Pune", link: "best-urbania-on-rent-in-pune" }
    ];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania Monthly Corporate Hire Pune",
  "image": "https://urbaniaonrentpune.in/assets/images/urbania-monthly-corporate-hire-pune.jpg",
  "description": "Urbania Monthly Corporate Hire Pune offers AC and non-AC Urbania buses for long-term corporate rentals. Ideal for employee transport, office commute, IT companies, and business travel. Chauffeur-driven buses ensure safe, comfortable, and reliable corporate transportation in Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Urbania on Rent in Pune"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "950",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "12000",
    "availability": "https://schema.org/InStock",
    "url": "https://urbaniaonrentpune.in/urbania-monthly-corporate-hire-pune"
  }
};






    return (
        <div>
            <Helmet>
  <title>
    Call:+91 9209423113 | Urbania Monthly Corporate Hire Pune | AC & Luxury Corporate Bus Rental 
  </title>

  <meta
    name="description"
    content="Book Urbania Monthly Corporate Hire Pune for long-term employee transport, office commute, and business travel. AC and non-AC Urbania buses with chauffeur-driven service ensure safe and comfortable corporate transportation in Pune."
  />

  <meta
    name="keywords"
    content="Urbania Monthly Corporate Hire Pune, Corporate Urbania Monthly Rental Pune, Urbania Long Term Hire Pune, Urbania for Company Transportation Pune, Corporate Employee Transport Urbania Pune, Urbania Office Commute Pune, Urbania AC Corporate Bus Pune, Affordable Corporate Urbania Pune, Chauffeur Driven Corporate Urbania Pune, Urbania for IT Companies Pune, Urbania Contract Hire Pune, Best Corporate Urbania Rental Pune, Reliable Corporate Urbania Service Pune, Urbania for Business Travel Pune, Monthly Urbania Bus Hire Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <div
                className="breadcumb-wrapper"
                
                data-overlay="black"
                data-opacity="3"
            >
                <div className="container">
                    <div className="breadcumb-content text-center">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/39.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>



                            <div className="shambhu-services">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="sh-service-card">

                                        <div className="sh-service-left">
                                            <div className="sh-service-icon">
                                                🚌
                                            </div>
                                        </div>

                                        <div className="sh-service-content">
                                            <h4 className="sh-service-title">{service.name}</h4>
                                            <p className="sh-service-desc">{service.description}</p>
                                        </div>

                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Urbania On rent in Pune </span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Urbania on rent in Pune </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919209423113" className="pc-call">+91 9209423113</a>
                                            <a href="tel:+917620411277 " className="pc-call">+91 7620411277 </a>
                                            <a href="tel:+919284718314" className="pc-call">+91 9284718314</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919209423113"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919209423113" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@urbaniaonrentpune.in" className="pc-email">
                                            booking@urbaniaonrentpune.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Urbania on rent in pune</strong><br />
                                            Saket Tata Power CHS, Swami Samarth Marg,
                                            Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                                            Maharashtra India - 400703
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Urbaniamonthlycorporatehire;